export default "__VITE_ASSET__CxcVQ_2k__"